/**
 * Mobile Menu - Accordion (custom, sans Foundation AccordionMenu)
 */

import $ from 'jquery';
import whatInput from 'what-input';
import { setFocusTrap, removeFocusTrap } from '../utils/focusTrap';

const LABELS = {
  open: 'Ouvrir le menu de navigation',
  close: 'Fermer le menu de navigation',
};

window.addEventListener('DOMContentLoaded', () => {
  const $menuMain = $('.js-main-menu');
  const $menuToggle = $('.js-menu-toggle');
  const $menuMobileContainer = $('.js-mobile-menu');

  if (!$menuMain.length || !$menuMobileContainer.length) return;
  if ($menuMobileContainer.find('.accordion-menu').length) return;

  const $responsiveMenu = $menuMobileContainer.closest('.responsive-menu');

  const $nav = $('<nav>', { 'aria-label': 'Menu principal' });
  $menuMain.clone(false, false).appendTo($nav);
  $nav.appendTo($menuMobileContainer);

  const $extras = $('.top__extras');
  if ($extras.length) {
    $extras.clone(false, false).removeClass('top__extras').addClass('mobile-extras').appendTo($menuMobileContainer);
  }

  const $mobileMenu = $menuMobileContainer.find('.js-main-menu').first();

  $mobileMenu.find('.level-1').unwrap();

  $mobileMenu.find('.field--name-focus, .menu-item--focus').remove();
  $mobileMenu.find('.has-focus').removeClass('has-focus');

  $mobileMenu.add($mobileMenu.find('ul')).removeClass('dropdown submenu is-dropdown-submenu vertical');
  $mobileMenu.find('li').removeClass('is-dropdown-submenu-parent is-dropdown-submenu-item is-submenu-item opens-right opens-left has-3-levels menu-item--expanded menu-item--collapsed');

  $mobileMenu.add($mobileMenu.find('ul')).removeAttr('data-dropdown-menu data-submenu role aria-multiselectable');

  $mobileMenu.find('[id]').removeAttr('id');

  $mobileMenu.find('[aria-controls]').removeAttr('aria-controls');
  $mobileMenu.find('[aria-haspopup]').removeAttr('aria-haspopup aria-label');
  $mobileMenu.find('a[role]').removeAttr('role');

  $mobileMenu.find('li').removeAttr('role aria-controls aria-expanded');

  $mobileMenu.addClass('accordion-menu');

  let submenuCounter = 0;
  $mobileMenu.find('li').each(function () {
    const $li = $(this);
    const $submenu = $li.children('ul');
    if (!$submenu.length) return;

    $li.addClass('is-accordion-submenu-parent');

    let $toggle = $li.children('button').first();
    if (!$toggle.length) $toggle = $li.children('a').first();
    if (!$toggle.length) return;

    const submenuId = 'mob-submenu-' + (++submenuCounter);
    const toggleId = 'mob-toggle-' + submenuCounter;

    $submenu.attr({ id: submenuId, 'aria-labelledby': toggleId }).hide();
    $toggle.attr({ id: toggleId, 'aria-expanded': 'false', 'aria-controls': submenuId });
  });

  $mobileMenu.on('click.accordion', '.is-accordion-submenu-parent > button, .is-accordion-submenu-parent > a', function (e) {
    const $toggle = $(this);
    const $li = $toggle.closest('.is-accordion-submenu-parent');
    const $submenu = $li.children('ul');

    if (!$submenu.length) return;

    e.preventDefault();
    const isExpanded = $toggle.attr('aria-expanded') === 'true';

    if (isExpanded) {
      $toggle.attr('aria-expanded', 'false');
      $submenu.slideUp(200);
    } else {
      $li.siblings('.is-accordion-submenu-parent').each(function () {
        const $sibToggle = $(this).children('button, a[aria-expanded]').first();
        if ($sibToggle.attr('aria-expanded') === 'true') {
          $sibToggle.attr('aria-expanded', 'false');
          $(this).children('ul').slideUp(200);
        }
      });
      $toggle.attr('aria-expanded', 'true');
      $submenu.slideDown(200);
    }
  });

  $responsiveMenu.attr('aria-hidden', 'true');

  const openNav = () => {
    document.body.classList.add('nav-open');
    $responsiveMenu.attr('aria-hidden', 'false');
    $menuToggle.attr({ 'aria-expanded': 'true', 'aria-label': LABELS.close });
    setFocusTrap($menuMobileContainer.get(0));
    $mobileMenu.find('a:visible, button:visible').first().get(0)?.focus();
  };

  const closeNav = () => {
    document.body.classList.remove('nav-open');
    $responsiveMenu.attr('aria-hidden', 'true');
    $menuToggle.attr({ 'aria-expanded': 'false', 'aria-label': LABELS.open });
    removeFocusTrap($menuMobileContainer.get(0));
    if (whatInput?.ask && whatInput.ask('intent') === 'keyboard') {
      $menuToggle.get(0).focus();
    }
  };

  $menuToggle.on('click', (ev) => {
    ev.preventDefault();
    if (!document.body.classList.contains('nav-open')) {
      openNav();
    } else {
      closeNav();
    }
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      closeNav();
    }
  });
});
